import React, {useEffect, useState} from 'react';
import {Layout} from "antd";
import {Outlet, useLocation} from "react-router-dom";
import {useMainLayoutContext} from "../index";
import {AbilityUtil} from "../../custom/permission/Can";
import {ActionKeys, SubjectName} from "../../custom/permission/Ability";
import Error403 from "../../common/error/Error403";
import SalaryList from "../../components/hrm/wage/salary";

const {Content} = Layout

function LayoutContent() {

    const {workspaceKeys, siderData} = useMainLayoutContext()

    const [forbidden, setForbidden] = useState(false)
    const [forbiddenSalary, setForbiddenSalary] = useState(false)

    const location = useLocation()

    useEffect(() => {

        const debounce = setTimeout(() => {

            const path = location.pathname

            let isSett = path.includes("/setting/")

            if (isSett) {
                setForbidden(!AbilityUtil.allow(ActionKeys.SETTING, SubjectName.tnp, {}))
            } else {

                const pathname = location.pathname

                const parentObject = siderData?.find(item => pathname.includes(item.key))

                if (pathname.includes("add") || pathname.includes("create")) {
                    const actionObject = parentObject?.action
                    setForbidden(!AbilityUtil.allow(ActionKeys.CREATE, actionObject.subjectName, {}))
                } else {
                    setForbidden(!AbilityUtil.allow(ActionKeys.READ, parentObject?.name, {}))
                    setForbiddenSalary(!AbilityUtil.allow(ActionKeys.READ, SubjectName.salaryTable, {}))
                }
            }
        }, 200)

        return () => {
            clearTimeout(debounce)
        }
    }, [location.pathname, workspaceKeys, siderData])

    return (
        <Content
            style={{
                background: "var(--primary-bg)",
                overflow: "hidden",
                fontSize: "var(--primary-text)",
                lineHeight: "var(--primary-line-height)",
                padding: "11px 13px"
            }}
        >
            {forbidden === null ? <></> : (forbidden ? (forbiddenSalary ? <Error403 /> : <SalaryList/>)  : <Outlet/>)}
        </Content>
    );
}

export default LayoutContent;